import { useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import ReCAPTCHA from "react-google-recaptcha";
import "./Contact.css";

const Contact = () => {
  const formRef = useRef(null);
  const [token, setToken] = useState("");
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState("Send");
  const [status, setStatus] = useState({});
  const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const handleCaptcha = (token) => {
    setToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setStatus({
        success: false,
        message: "Please complete the CAPTCHA before submitting.",
      });
      return;
    }

    setButtonText("Sending...");

    const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
    if (!apiEndpoint) {
      setButtonText("Send");
      setStatus({
        success: false,
        message: "Configuration error. Please contact the site owner.",
      });
      return;
    }

    const honeypot = formRef.current
      ? new FormData(formRef.current).get("honeypot") || ""
      : "";

    try {
      let response = await fetch(`${apiEndpoint}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({ ...formDetails, token, honeypot }),
      });
      setButtonText("Send");
      let result = await response.json();
      if (result.code === 200) {
        setFormDetails(formInitialDetails);
        setStatus({
          success: true,
          message:
            "Message sent successfully, Henri will contact you through mail.",
        });
      } else {
        setStatus({
          success: false,
          message: result.message || "Something went wrong, please try again later.",
        });
      }
    } catch (error) {
      setButtonText("Send");
      setStatus({
        success: false,
        message: "CAPTCHA failed, please try again.",
      });
    }
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-item-center">
          <Col md={6}>
            <img src={contactImg} alt="Contact Us" />
          </Col>
          <Col md={6}>
            <h2>Get In Touch</h2>
            <form ref={formRef} onSubmit={handleSubmit} action="action-token">
              <Row>
                <Col size={12} sm={6} className="px-1">
                  <input
                    type="text"
                    value={formDetails.firstName}
                    placeholder="First Name"
                    autoComplete="given-name"
                    aria-label="First name"
                    onChange={(e) => {
                      onFormUpdate("firstName", e.target.value);
                    }}
                    required={true}
                  />
                </Col>
                <Col size={12} sm={6} className="px-1">
                  <input
                    type="text"
                    value={formDetails.lastName}
                    placeholder="Last Name"
                    autoComplete="family-name"
                    aria-label="Last name"
                    onChange={(e) => {
                      onFormUpdate("lastName", e.target.value);
                    }}
                    required={true}
                  />
                </Col>
                <Col size={12} sm={6} className="px-1">
                  <input
                    type="email"
                    value={formDetails.email}
                    placeholder="Email Address"
                    autoComplete="email"
                    aria-label="Email address"
                    onChange={(e) => {
                      onFormUpdate("email", e.target.value);
                    }}
                    required={true}
                  />
                </Col>
                <Col size={12} sm={6} className="px-1">
                  <input
                    type="tel"
                    value={formDetails.phone}
                    placeholder="Phone Number"
                    autoComplete="tel"
                    aria-label="Phone number"
                    onChange={(e) => {
                      onFormUpdate("phone", e.target.value);
                    }}
                  />
                </Col>
                <Col size={12} className="px-1">
                  <textarea
                    rows="6"
                    value={formDetails.message}
                    placeholder="Message"
                    aria-label="Message"
                    onChange={(e) => {
                      onFormUpdate("message", e.target.value);
                    }}
                    required={true}
                  />
                  <div className="form-actions">
                    <div className="recaptcha-container">
                      {recaptchaSiteKey ? (
                        <ReCAPTCHA
                          sitekey={recaptchaSiteKey}
                          onChange={handleCaptcha}
                        />
                      ) : (
                        <p className="danger">
                          Form configuration error. Please contact the site owner.
                        </p>
                      )}
                    </div>
                    <button type="submit" disabled={!recaptchaSiteKey}>
                      <span>{buttonText}</span>
                    </button>
                  </div>
                </Col>
                <input
                  name="honeypot"
                  className="visually-hidden"
                  tabIndex="-1"
                  autoComplete="off"
                  aria-hidden="true"
                />
                {status.message && (
                  <p
                    className={status.success === false ? "danger" : "success"}
                  >
                    {status.message}
                  </p>
                )}
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
